import React, { memo, useEffect, useState } from "react";
import { environment } from "src/config/environment";

const DynamicLogo = ({ redirectToHome, srcOverride }) => {
	const [Logo, setLogo] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {
		const ImportIcon = async () => {
			try {
				// const logoPath = await import(`public/icon/${environment.REACT_APP_INSTANCE_NAME}.svg`);
				const logoPath = await import(`public/icon/LeftLogo${environment.REACT_APP_INSTANCE_NAME}.svg?url`);
				setLogo(logoPath.default);
			} catch (err) {
				console.error("Error loading logo:", err);
				setError("Logo not found");
			}
		};
		ImportIcon();
	}, []);

	// srcOverride wins (e.g. the branding preview's uploaded full logo); otherwise
	// fall back to the bundled theme logo. The default is always loaded so it can
	// take over again the moment the override is cleared (discard).
	const resolved = srcOverride || Logo;
	if (error && !resolved) return <div>{error}</div>;
	if (!resolved) return null;

	// An overridden logo (e.g. an uploaded full logo in the branding preview) is
	// clamped to the 200×32 spec box so an odd-sized image can't overflow the navbar.
	if (srcOverride) {
		return (
			<img
				src={resolved}
				className="cursor-pointer"
				style={{ maxWidth: 200, maxHeight: 32, width: "auto", height: "auto", objectFit: "contain" }}
				onClick={redirectToHome}
				alt="Logo"
			/>
		);
	}

	return <img src={resolved} className="min-w-32 w-fit item-center text-start cursor-pointer" onClick={redirectToHome} alt="Logo" />;
};

export default memo(DynamicLogo);
